import { type FormValidateInput, isNotEmpty } from '@mantine/form';
import { type CascadeEditorFormValues } from './types';

const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;

const validateEndAt = (value: string, values: CascadeEditorFormValues) => {
    if (!value) {
        return 'Заполните поле';
    }

    if (!values.startAt || !timeRegex.test(values.startAt) || !timeRegex.test(value)) {
        return 'Некорректное время';
    }

    const [startH, startM] = values.startAt.split(':').map(Number);
    const [endH, endM] = value.split(':').map(Number);

    if (endH * 60 + endM <= startH * 60 + startM) {
        return 'Время окончания должно быть позже времени начала';
    }

    return null;
};

const validateMaxAmount = (value: number, values: CascadeEditorFormValues) => {
    if (!value || value <= 0) {
        return 'Максимальная сумма должна быть больше 0';
    }

    if (values.minAmount !== undefined && value <= values.minAmount) {
        return 'Максимальная сумма должна быть больше минимальной';
    }

    return null;
};

export const validate: FormValidateInput<CascadeEditorFormValues> = {
    name: isNotEmpty('Заполните поле'),
    currency: isNotEmpty('Заполните поле'),
    requisiteType: isNotEmpty('Заполните поле'),
    startAt: isNotEmpty('Заполните поле'),
    endAt: validateEndAt,
    minAmount: (value: number) => (value < 0 ? 'Минимальная сумма не может быть отрицательной' : null),
    maxAmount: validateMaxAmount,
};
